import * as types from './actionTypes';
import accountService from '../services/accountService';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import ToastrService from '../services/toastrService';
import analyticsService from '../services/analyticsService';

let notificationCountHandle = null;

export function login(email, password){
    return function(dispatch) {
        dispatch({type: types.CLEAR_LOGIN_ERROR});
        return accountService.login(email, password).then(payload => {            
            dispatch({ type: types.LOGIN_SUCCESS, payload });
            dispatch(getUser(true));

        }).catch(error => {
            if(error.message === '["You need to confirm your email address"]') {
                dispatch(push(`/Account/ConfirmEmail?email=${email}`));
            }
            else {
                dispatch({type: types.SET_LOGIN_ERROR, error});
            }            
        });
    };
}

export function clearLoginError() {
    return function(dispatch) {
        dispatch({ type: types.CLEAR_LOGIN_ERROR });
    };  
}

export function clearSignupError() {
    return function(dispatch) {
        dispatch({ type: types.CLEAR_SIGNUP_ERROR });
    };  
}

export function setLoginError(error) {
    return { type: types.SET_LOGIN_ERROR, error: new Error(error) };
}

export function setSignupError(error) {
    return { type: types.SET_SIGNUP_ERROR, error: new Error(error) };
}

export function updateActiveProfile(id){
    return function(dispatch, getState) {
        const state = getState();
        dispatch({ type: types.UPDATE_ACTIVE_PROFILE, id });
        const activeProfile = state.account.user.enabledProfiles.find(p => p.ID === id);
        if(activeProfile) {
            const toastrService = new ToastrService();
            toastrService.showSuccess('', `Your active profile has been switched to '${activeProfile.DisplayName}'`);
            dispatch(refreshNotificationCount(activeProfile.ID));
        }
    };
}

export function refreshNotificationCount(profileID) {
    return function(dispatch, getState) {
        clearNotificationCountHandle();
        dispatch(getNotificationCount(profileID));
        notificationCountHandle = setInterval(() => {
            dispatch(getNotificationCount(profileID));
        }, 60000);
    }
}

function getNotificationCount(profileID){
    return function(dispatch, getState) {
        return accountService.getNotificationCount(profileID).then(data => {
            if(data) {
                const state = getState();
                const activeProfile = state.account.user.activeProfile;
                if(activeProfile && activeProfile.ID === profileID) {
                    if(activeProfile.UnreadEmailCount !== data.UnreadEmailCount || activeProfile.UnreadNotificationCount !== data.UnreadNotificationCount) {
                        //if we have the same profile open and the values have changed before dispatching as otherwise we'll trigger a re-render for no reason
                        const payload = { ...data, profileID };
                        dispatch({ type: types.GET_NOTIFICATION_COUNT, payload });
                    }
                }                
            }
        }).catch(error => {
            //do nothing
        });
    };
}

export function clearNotificationCountHandle() {
    if(notificationCountHandle) {
        clearInterval(notificationCountHandle);
    }
}

export function logout(next, showSuccessToast = true){
    return { type: types.LOGOUT, payload: { next, showSuccessToast } };
}

function dispatchStatusUpdate(dispatch, type, status) {
    let loadingStatus = {status: status};
    dispatch({ type, loadingStatus });
}

export function loginSuccess(token) {
    return { type: types.LOGIN_SUCCESS, payload: { access_token: token } };
}

export function getUser(showSuccessToast = false, isLogin = true){
    return function(dispatch, getState) {
        dispatch({ type: types.SET_USER_LOADING });
        return accountService.getUser().then(user => {
            if(user) {
                dispatch({ type: types.GET_USER_SUCCESS, user });
                dispatch({ type: types.CLEAR_USER_LOADING });
                if(showSuccessToast) {
                    const toastrService = new ToastrService();
                    toastrService.showSuccess('', `You have ${ isLogin ? 'logged in' : 'signed up' } successfully!`);
                }
                const state = getState();
                if(state.account.user && state.account.user.activeProfile) {
                    const activeProfileID = state.account.user.activeProfile.ID;                    
                    dispatch(refreshNotificationCount(activeProfileID));
                }
            }
            return user;
        }).catch(error => {
            dispatch({ type: types.CLEAR_USER_LOADING });
            throw(error);
        });
    };
}

export function registerExternal(email){
    return function(dispatch) {
        dispatch({type: types.CLEAR_LOGIN_ERROR});
        return accountService.registerExternal(email).then(payload => {        
            //call login success again as this call will give us a longer token for the registered user
            dispatch({ type: types.LOGIN_SUCCESS, payload });
            dispatch({ type: types.SIGNUP_SUCCESS });
            dispatch(getUser(true, false));
            logNewSignup();
            return payload;

        }).catch(error => {
            throw(error);
        });
    };
}

function logNewSignup() {
    try {
        analyticsService.logEventGA('user', 'signup');
        analyticsService.logEventFB('CompleteRegistration', false);
        analyticsService.logEventBing('User', 'Sign up', 'User sign up');
        //analyticsService.logRegistrationTwitter();
    }
    catch(error) {
        //do nothing
    }
}

export function confirmEmail(email, code){
    return function(dispatch) {
        return accountService.confirmEmail(email, code).then(payload => {            
            dispatch({ type: types.CONFIRM_EMAIL, email });
            return payload;
        }).catch(error => {
            throw(error);
        });
    };
}

export function resendConfirmationEmail(email){
    return function(dispatch) {
        return accountService.resendConfirmationEmail(email).then(payload => {       
            return payload;
        }).catch(error => {
            throw(error);
        });
    };
}

export function signup(email, password, firstName, surname, dob, gender, city, region, country, longitude, latitude){    
    return function(dispatch) {
        dispatch({type: types.CLEAR_SIGNUP_ERROR});
        return accountService.signup(email, password, firstName, surname, dob, gender, city, region, country, longitude, latitude).then(payload => {   
            dispatch(push(`/Account/ConfirmEmail?email=${email}`));
            logNewSignup();
        }).catch(error => {
            if(error.message === 'Conflict') {
                dispatch({type: types.SET_SIGNUP_ERROR, error: new Error('There is already an account registered with that email address, did you mean to log in?')});
            }
            else {                
                dispatch({type: types.SET_SIGNUP_ERROR, error});
            }
        });
    };
}

export function forgotPassword(email){
    return function(dispatch) {
        return accountService.forgotPassword(email).then(payload => {   
            return payload;
        }).catch(error => {
            throw(error);
        });
    };
}

export function resetPassword(email, code, password){
    return function(dispatch) {
        return accountService.resetPassword(email, code, password).then(payload => {   
            return payload;
        }).catch(error => {
            throw(error);
        });
    };
}

export function closeAccount(reason, removeFromMailingList){
    return function(dispatch) {
        return accountService.closeAccount(reason, removeFromMailingList).then(payload => {         
            dispatch(logout('/', false));
            return true;
        }).catch(error => {
            throw(error);
        });
    };
}

export function getUserInfo(accessToken) {
    return wrapServiceCall(() => accountService.getUserInfo(accessToken));
}

export function addLogin(accessToken) {
    return wrapServiceCall(() => accountService.addLogin(accessToken));
}

export function removeLogin(loginProvider, loginProviderUserId) {
    return wrapServiceCall(() => accountService.removeLogin(loginProvider, loginProviderUserId));
}

export function getExternalLoginsList(returnUrl) {
    return wrapServiceCall(() => accountService.getExternalLoginsList(returnUrl));
}

export function getExternalLogins() {
    return wrapServiceCall(() => accountService.getExternalLogins());
}

export function wrapServiceCall(func) {
    //we just want to make a service call without dispatching anything - so we can go through middleware and check the token
    return function(dispatch) {
        return func()
            .then(data => data);    
    }
}

export function changePassword(currentPassword, newPassword) {
    return wrapServiceCall(() => accountService.changePassword(currentPassword, newPassword));
}

export function setPassword(password) {
    return wrapServiceCall(() => accountService.setPassword(password));
}